import {Helmet} from 'react-helmet';

function Java() {
    return (
        <div className="Java" data-pym-src="https://www.jdoodle.com/embed/v0/49oh">
           <Helmet>
             <script src="https://www.jdoodle.com/assets/jdoodle-pym.min.js" type="text/javascript"></script>   
             </Helmet>  
        </div>
    )
}

export default Java;
